// extracted by mini-css-extract-plugin
var _1 = "ZebraDetailStyle-module__detail___B90Uc";
var _2 = "ZebraDetailStyle-module__label___IizEs";
var _3 = "ZebraDetailStyle-module__value___d7FWj";
export { _1 as "detail", _2 as "label", _3 as "value" }
